import * as R from 'ramda';

export const replacerCost = (cost: string | number | null | undefined) => {
    if (typeof cost === 'number') {
        return cost;
    }

    const separator = new Intl.NumberFormat('ru').format(1111).replace(/1/g, '');

    return cost ? Number(cost?.replace(',', '.')?.replaceAll(' ', '')?.replaceAll(separator, '')) : 0;
};

export const replacerCostString = (cost: string | number | null | undefined) => {
    if (typeof cost === 'number') {
        return String(cost);
    }

    const separator = new Intl.NumberFormat('ru').format(1111).replace(/1/g, '');

    return cost ? cost?.replace(',', '.')?.replaceAll(' ', '')?.replaceAll(separator, '') : '0';
};

export const replacerCostIfValue = (cost: any) => {
    if (R.isNil(cost) || (typeof cost === 'string' && !cost)) {
        return null;
    }

    return replacerCost(cost);
};
